"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var courtesyCarPerks = [
    {
        description: "Small 3 door hatchback",
        boldDescription: "more than 1/4 mile",
        level: {
            basic: { included: true },
            enhanced: { included: false },
            none: { included: null },
        }
    },
    {
        description: "Medium family sized car with 5 doors, or a 7 seater",
        boldDescription: "up to 10 miles",
        level: {
            basic: { included: false },
            enhanced: { included: true },
            none: { included: null },
        }
    }
];
exports.default = courtesyCarPerks;
//# sourceMappingURL=CourtesyCarPerks.js.map